export const messages = {
  en: {
    partnerPool: {
      queryCondition: 'Query Conditions',
      selectName: 'Please select name',
      selectPartner: 'Please select partner',
      selectStatus: 'Please select status',
      enable: 'Enable',
      disable: 'Disable',
      query: 'Query',
      partner: 'Partner',
      add: 'Add',
      name: 'Name',
      status: 'Status',
      createTime: 'Create Time',
      usage: 'Usage Instructions',
      operation: 'Operation',
      edit: 'Edit',
      delete: 'Delete',
      requiredName: 'Required, please enter name',
      requiredPartner: 'Required, please select partner',
      optionalUsage: 'Optional, please enter usage instructions',
      save: 'Save',
      cancel: 'Cancel',
      validateError: 'Validation failed, please check input',
      saveSuccess: 'Save successfully',
      saveFailed: 'Save failed',
      confirmOperation: 'Please confirm your operation',
      confirmDelete: 'Confirm to delete partner configuration',
      confirmDeleteBtn: 'Confirm Delete',
      deleteSuccess: 'Delete successfully',
      deleteFailed: 'Delete failed',
      requiredStatus: 'Required, please select status'
    }
  },
  zh: {
    partnerPool: {
      queryCondition: '查询条件',
      selectName: '请选择名称',
      selectPartner: '请选择合作商',
      selectStatus: '请选择状态',
      enable: '启用',
      disable: '停用',
      query: '查询',
      partner: '合作商',
      add: '添加',
      name: '名称',
      status: '状态',
      createTime: '创建时间',
      usage: '使用说明',
      operation: '操作',
      edit: '修改',
      delete: '删除',
      requiredName: '必填，请填写名称',
      requiredPartner: '必填，请选择合作商',
      optionalUsage: '选填，请填写使用说明',
      save: '保存',
      cancel: '取消',
      validateError: '验证失败，请检查输入',
      saveSuccess: '保存成功',
      saveFailed: '保存失败',
      confirmOperation: '请确认您的操作',
      confirmDelete: '确定删除支付配置',
      confirmDeleteBtn: '确认删除',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败',
      requiredStatus: '必填，请选择状态'
    }
  }
}